<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: String, required: true },
  error: { type: String, default: null },
  validationRules: { type: Object, required: true },
});

const emit = defineEmits([ 'update:modelValue' ]);

const infos = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label"
      for="access"
    >{{ trans('addresses.details.form.field.access.label') }}</label>
    <div class="form-field__input field-input input-text">
      <textarea
        id="access"
        v-model="infos"
        type="text"
        :minlength="validationRules.min_length"
        :maxlength="validationRules.max_length"
        name="access"
        :class="{ error: error !== null }"
        :placeholder="trans('addresses.details.form.field.access.placeholder')"
        @focusout="$emit('focusout')"
      />
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>
